module.exports = __webpack_public_path__ + "img/file-check-02.365a2c6c.svg";